// extracted by mini-css-extract-plugin
var _1 = "cardTitle__xwgwL";
var _2 = "main__akGGv";
var _3 = "row__a0oO3";
var _4 = "section__zMVEK";
export { _1 as "cardTitle", _2 as "main", _3 as "row", _4 as "section" }
export default { "cardTitle": _1, "main": _2, "row": _3, "section": _4 }
